import React from 'react';
import '@ui5/webcomponents-fiori/dist/illustrations/UnableToLoad.js';
import { IllustrationMessageType } from '@ui5/webcomponents-react';
import { useTranslation } from 'react-i18next';

import { ErrorPage } from '../ErrorPage';

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <ErrorPage
      withReturnToMainPageButton
      messageType={IllustrationMessageType.UnableToLoad}
      titleText={t('not-found-title')}
      subtitleText={t('not-found-subtitle')}
      data-help-id="not-found-illustration"
    />
  );
};
